import { AppModule } from 'app/module';
import { trackGa4 } from 'util/googleAnalytics';
import Template from './template.hbs';
import './styles.scss';

export class ProposalItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    getPropsFromDom() {
        const isSplitView = (this.dom.el.getAttribute('data-splitview') === 'true');
        let keywords = null;
        let locations = null;

        if (isSplitView) {
            keywords = this.dom.el.getAttribute('data-keywords') !== null
                ? decodeURIComponent(this.dom.el.getAttribute('data-keywords')) : null;
            locations = this.dom.el.getAttribute('data-locations') !== null
                ? decodeURIComponent(this.dom.el.getAttribute('data-locations')) : null;
        } else {
            keywords = this.dom.el.getAttribute('data-keywords');
            locations = this.dom.el.getAttribute('data-locations');
        }

        const eventName = this.dom.el.getAttribute('data-event-name');

        return {
            keywords,
            locations,
            eventName,
            keywordSlug: false,
            locationSlug: false,
            page: false,
            radius: 0,
        };
    }

    domBindings() {
        return {
            anchor: '.m-proposalItem__anchor',
        };
    }

    domEvents() {
        const isSplitView = (this.dom.el.getAttribute('data-splitview') === 'true');
        if (this.dom.anchor && isSplitView) {
            this.dom.anchor.addEventListener('click', (e) => this.proposalLinkClicked(e));
        }
    }

    proposalLinkClicked(e) {
        if (e) e.preventDefault();
        this.events.emit('proposalLinkClicked', this.props);

        let elementDetail = null;

        if (this.props.eventName === 'keywords') {
            elementDetail = 'Keywords';
        } else if (this.props.eventName === 'locations') {
            elementDetail = 'Locations';
        } else if (this.props.eventName === 'random') {
            elementDetail = 'Random';
        }

        trackGa4({
            event: 'click_element',
            element: 'JOBS: Proposals',
            element_detail: elementDetail,
        });
    }
}
